/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteSetupParameterKindsEntry } from '../../models/delete-setup-parameter-kinds-entry';

export interface DeleteSetupParameterKinds$Params {
      body: Array<DeleteSetupParameterKindsEntry>
}

export function deleteSetupParameterKinds(http: HttpClient, rootUrl: string, params: DeleteSetupParameterKinds$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteSetupParameterKinds.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteSetupParameterKinds.PATH = '/api/v1/SetupParameter/DeleteSetupParameterKindsList';
